import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ServiceCard = ({ 
  icon: Icon, 
  title, 
  description, 
  href, 
  className = '' 
}) => {
  return (
    <Link 
      to={href}
      className={`service-card group block p-8 bg-white dark:bg-slate-800 rounded-2xl border border-slate-100 dark:border-slate-700 shadow-sm hover:shadow-xl ${className}`}
      data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="icon-container w-14 h-14 rounded-xl bg-sky-50 dark:bg-sky-900/30 flex items-center justify-center mb-6">
        <Icon className="w-7 h-7 text-sky-600 dark:text-sky-400 transition-colors duration-300" />
      </div>
      <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3 group-hover:text-sky-600 transition-colors duration-300">
        {title}
      </h3>
      <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed mb-4">
        {description}
      </p>
      <div className="flex items-center gap-2 text-sky-600 dark:text-sky-400 font-medium text-sm">
        <span>Learn more</span>
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
      </div>
    </Link>
  );
};

export const ServiceCardLarge = ({ 
  icon: Icon, 
  title, 
  description, 
  features = [],
  href, 
  className = '' 
}) => {
  return (
    <Link 
      to={href}
      className={`service-card group block p-8 lg:p-10 bg-white dark:bg-slate-800 rounded-2xl border border-slate-100 dark:border-slate-700 shadow-sm hover:shadow-xl ${className}`}
      data-testid={`service-card-large-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-start justify-between mb-6">
        <div className="icon-container w-16 h-16 rounded-xl bg-sky-50 dark:bg-sky-900/30 flex items-center justify-center">
          <Icon className="w-8 h-8 text-sky-600 dark:text-sky-400 transition-colors duration-300" />
        </div>
        <ArrowRight className="w-5 h-5 text-slate-300 dark:text-slate-600 group-hover:text-sky-600 dark:group-hover:text-sky-400 group-hover:translate-x-1 transition-all duration-300" />
      </div>
      <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-3 group-hover:text-sky-600 dark:group-hover:text-sky-400 transition-colors duration-300">
        {title}
      </h3>
      <p className="text-slate-600 dark:text-slate-300 leading-relaxed mb-6">
        {description}
      </p>
      {features.length > 0 && (
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
              <div className="w-1.5 h-1.5 rounded-full bg-sky-500" />
              {feature}
            </li>
          ))}
        </ul>
      )}
    </Link>
  );
};
